
class CYMailUser extends HTMLElement {

	constructor() {
        super();
		if (document.cookie.includes('cymailcms=1'))
			this.init();		
	}

	init() {
		const _html = `<a class="lnkEdit" href="/internal/post/edit/${this.getAttribute('data-id')}" target="_blank" rel="noindex nofollow">Edit Post</a>`;
		this.innerHTML += _html;
	}

	connectedCallback() {
		
	}
	
	disconnectedCallback() {
		
    }
}

if (!customElements.get("cymail-user"))
	customElements.define("cymail-user", CYMailUser);